import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import { getAllApis } from '@/api/api';
import { UpdateCasbin, getPolicyPathByAuthorityId } from '@/api/casbin';
export default {
  name: 'Apis',
  props: {
    row: {
      default: function _default() {
        return {};
      },
      type: Object
    }
  },
  data: function data() {
    return {
      apiTreeData: [],
      apiTreeIds: [],
      needConfirm: false,
      apiDefaultProps: {
        children: 'children',
        label: 'description'
      }
    };
  },
  methods: {
    nodeChange: function nodeChange() {
      this.needConfirm = true;
    },
    // 暴露给外层使用的切换拦截统一方法
    enterAndNext: function enterAndNext() {
      this.authApiEnter();
    },
    // 创建api树方法
    buildApiTree: function buildApiTree(apis) {
      var apiObj = new Object();
      apis && apis.map(function (item) {
        item.onlyId = "p:" + item.path + "m:" + item.method;
        if (Object.prototype.hasOwnProperty.call(apiObj, item.apiGroup)) {
          apiObj[item.apiGroup].push(item);
        } else {
          Object.assign(apiObj, _defineProperty({}, item.apiGroup, [item]));
        }
      });
      var apiTree = [];
      for (var key in apiObj) {
        var treeNode = {
          ID: key,
          description: key + '组',
          children: apiObj[key]
        };
        apiTree.push(treeNode);
      }
      return apiTree;
    },
    // 关联关系确定
    authApiEnter: function authApiEnter() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var checkArr, casbinInfos, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              checkArr = _this.$refs.apiTree.getCheckedNodes(true);
              casbinInfos = [];
              checkArr && checkArr.map(function (item) {
                var casbinInfo = {
                  path: item.path,
                  method: item.method
                };
                casbinInfos.push(casbinInfo);
              });
              _context.next = 5;
              return UpdateCasbin({
                authorityId: _this.activeUserId,
                casbinInfos: casbinInfos
              });
            case 5:
              res = _context.sent;
              if (res.code == 0) {
                _this.$message({
                  type: 'success',
                  message: "api设置成功"
                });
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var res2, apis, res;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getAllApis();
          case 2:
            res2 = _context2.sent;
            apis = res2.data.apis;
            _this2.apiTreeData = _this2.buildApiTree(apis);
            _context2.next = 7;
            return getPolicyPathByAuthorityId({
              authorityId: _this2.row.authorityId
            });
          case 7:
            res = _context2.sent;
            _this2.activeUserId = _this2.row.authorityId;
            _this2.apiTreeIds = [];
            res.data.paths && res.data.paths.map(function (item) {
              _this2.apiTreeIds.push("p:" + item.path + "m:" + item.method);
            });
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
};